"use client";

import React from "react";

import { PropertyActionButtons } from "./PropertyActionButtons";

interface PropertyActionButtonsWrapperProps {
  propertyId: string;
  className?: string;
  editUrl?: string;
  compact?: boolean;
  propertyStatus?: string;
  status?: string;
  title?: string;
}

/**
 * PropertyActionButtonsWrapper - Полнофункциональная обертка для PropertyActionButtons
 *
 * Особенности:
 * - Интеграция с usePropertyActions хуком
 * - Optimistic updates для быстрого UX
 * - Error handling с пользовательскими уведомлениями
 * - Автоматическое логирование в timeline
 * - React 19 ready с useTransition
 * - Следует архитектурным паттернам проекта
 */
export const PropertyActionButtonsWrapper: React.FC<
  PropertyActionButtonsWrapperProps
> = ({
  propertyId,
  className,
  editUrl,
  compact = false,
  propertyStatus,
  title,
}) => {
  // All action logic is now handled internally by PropertyActionButtons component
  // This wrapper only passes down the necessary props without function callbacks

  return (
    <PropertyActionButtons
      propertyId={propertyId}
      className={className}
      editUrl={editUrl}
      compact={compact}
      publicationStatus={propertyStatus}
      title={title}
    />
  );
};

export default PropertyActionButtonsWrapper;
